import { PaymentMethodType } from "client/openapi";
import { useState, useEffect } from "react";

export default function ExternalPaymentMethodInput({
  setPaymentMethod,
  setPaymentMethodType,
}: {
  setPaymentMethod: (payment_method: string | undefined) => void;
  setPaymentMethodType: (
    paymentMethodType: PaymentMethodType | undefined
  ) => void;
}) {
  const [description, setDescription] = useState("");

  // Automatically set payment method when description changes
  useEffect(() => {
    if (description.trim()) {
      setPaymentMethod(description);
      setPaymentMethodType(PaymentMethodType.EXTERNAL_PAYMENT_METHOD);
    } else {
      setPaymentMethod(undefined);
      setPaymentMethodType(undefined);
    }
  }, [description, setPaymentMethod, setPaymentMethodType]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDescription(e.target.value);
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex-1">
        <input
          type="text"
          className="input"
          placeholder="How did the customer pay? (e.g., Cash, Check, Venmo, Pro Bono, etc.)"
          value={description}
          onChange={handleInputChange}
          maxLength={100}
          autoFocus
        />
      </div>
    </div>
  );
}
